import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { GetServerSidePropsResult } from 'next';
import getConfig from 'next/config';
import { PasskeyDevLogin } from '@components/PasskeyDevLogin';
import { useLazyQuery } from '@apollo/client';
import cookie from 'js-cookie';
import { getDevAuth } from '@cvent/passkey-admin-model/operations/authentication';
import { DEFAULT_AUTH_COOKIE_NAME } from '@cvent/nextjs/auth/constants';
import { setItem } from '@cvent/nextjs/utils/storage';

export const LOG = LoggerFactory.create('LoginHandler');

const { publicRuntimeConfig } = getConfig();

export const getServerSideProps = (): GetServerSidePropsResult<Record<string, unknown>> => {
  if (publicRuntimeConfig.DEV_LOGIN === 'true') {
    return { props: {} };
  }
  return {
    notFound: true
  };
};

function LoginPage(): JSX.Element {
  const router = useRouter();
  const { query } = router;

  const [loginQuery] = useLazyQuery(getDevAuth);

  const login = useCallback(
    async (event, formValues) => {
      // Authenticate user and generate access token for local development workflow

      const response = await loginQuery({
        variables: formValues.values
      });
      const responseValues = response.data.devAuth;
      LOG.debug(`DEV Login Response: ${JSON.stringify(responseValues)}`);

      if (response.data.devAuth.authorized) {
        cookie.set(DEFAULT_AUTH_COOKIE_NAME, responseValues?.accessToken);

        // const metadata = responseValues?.metadata;

        setItem('csrfToken', responseValues?.csrfToken);
        // setItem('accessToken', responseValues?.accessToken);
        // initializeStorage(metadata);
        router.push((query.returnUrl as string) || '/');
      }
    },
    [query.returnUrl, router, loginQuery]
  );

  return <PasskeyDevLogin onSubmit={login} />;
}

export default LoginPage;
